<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-17 18:55:51
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value" @click="clickBg">
    <GuideLight v-if="isShowGuideLight"></GuideLight>
  </div>
</template>

<script>
import Vue from "vue/dist/vue.js";
// import router from "../../../router";
let that = Vue.prototype;
import GuideLight from "../../GuideLight";
export default {
  components: { GuideLight },
  props: {},
  data() {
    return {
      value: false,
      title: "",
      message: "",
      callback: null,
      isShowGuideLight: true,
      userInfo: that.$userInfo
    };
  },
  watch: {
    value: function(newVal) {
      if (newVal) {
        this.$showToast({
          message: "戳右上，转发一下让朋友帮你集福",
          duration: 5000
        });
      } else {
        this.$hideToast();
      }
    }
  },
  computed: {},
  methods: {
    clickBg() {
      this.value = false;
    },
    clickClose() {
      this.value = false;
      this.callback("cancel");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style>
.mint-toast-text {
  font-size: 16px !important;
  line-height: 30px;
}
</style>
<style lang="css" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.msgbox {
  width: 80%;
  position: relative;
}

.msgbox .poster {
  width: 100%;
}

.msgbox .close {
  position: absolute;
  top: -0.65rem;
  right: -0.65rem;
  width: 0.6rem;
  height: 0.6rem;
  z-index: 1001;
}
</style>